import { Pipe, PipeTransform } from '@angular/core';

import { AttachmentModel, ThumbnailsDict } from '@models/module/fields/main';

@Pipe({
  name: 'imageSource',
})
export class ImageSourcePipe implements PipeTransform {
  transform(attachment: AttachmentModel): string {
    if (attachment.thumbnail50) {
      return `data:${attachment.mimeType};base64,${attachment.thumbnail50}`;
    }
    return ThumbnailsDict[attachment.mimeType] || ThumbnailsDict.default;
  }
}
